import { Injectable, inject } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { UntypedFormGroup, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { DNIAlreadyExistsValidator, DNIMediadorValidator } from '../Common/validators-dni';
import { RemoteCallCommonService, ICallParams } from './remote-call-common.service';
import { ColegiadosService } from './colegiados.service';

export interface IPersonaRecord {
    dni: string;
    nombre: string;
    apellido1: string;
    apellido2: string;
    empresa: string;
    tipo_empresa: string;
    cargo: string;
    direccion: string;
    codigo_postal: string;
    ciudad: string;
    pais: string;
    telefono: string;
    email: string;
    empresa_invitacion: string;     // Empresa que le ha invitado -> en invitado es la empresa del mediador pral
    acto_social: 0 | 1;
    [key: string]: any;
}
export interface IIncripcionRecord extends IPersonaRecord {

    id_inscripcion: number | any;
    id_padre: number | any;    // En inscrito pral null. En invitado el id_inscripción del pral
    relacion_padre: number | any;    //

    ha_asistido: boolean;
    fecha_asistencia: string | any; // Fecha en formato "aaaa/mm/dd HH:MM:SS"
    fecha_asistencia_cocktel: string | any; // Fecha en foramto "aaaa/mm/dd HH:MM:SS"

    fecha_envio_email: string | any; // Fecha en formato "aaaa/mm/dd HH:MM:SS"
    fecha_pendiente: string | any; // Fecha en formato "aaaa/mm/dd HH:MM:SS"

    con_factura: boolean;       // Si ha soliciatdo factura
    importe_factura: number | any;    // 0 si no ha habido factura

    codigo_qr: string;
    tipo_inscripcion: string;
    codigo_autorizacion: string;    // Código de autyorización del pago online

    fecha_alta: string;         // Fecha en formato "aaaa/mm/dd HH:MM:SS"
    empresa_inivitacion: string | any;
    foro1: string | any;
    foro2: string | any;

    codigo_reserva: string;   // código de reserva que se nevía a determinadas personas
    reservado: boolean;       // Si tiene asiento reservado o no


}
export interface IAllData extends IIncripcionRecord {
    lista_invitados: IPersonaRecord[];
}

export interface IRemoteRecordFormat {
    iaPral: IIncripcionRecord;
    ibInvitado: IIncripcionRecord | null;
    icAcompanantes: IIncripcionRecord[];
}


@Injectable({
    providedIn: 'root'
})
export class InscripcionesService {
    // private _current_info:IRemoteRecordFormat | null = null;
    private _colegiadosS = inject(ColegiadosService);

    
    public inscription_record = this.getEmptyRecord();
    public person_record = this.getEmptyPersonaRecord();
    public lista_invitados: IPersonaRecord[] = [];
    public static readonly TIPO_INSCRIPCION_MEDIADOR: string | number = 1;

    // ===========================================================================
    // ---------------------------------------------------------------------------
    constructor(private _RemoteCallCommonS: RemoteCallCommonService) { }

    // ---------------------------------------------------------------------------
    get form_validation_dni(): UntypedFormGroup {
        return new UntypedFormGroup({
            tipo_inscripcion: new UntypedFormControl('2', [Validators.required]),
            dni: new UntypedFormControl('', {
                validators: [Validators.required],
                updateOn: 'blur'
            }),
        }, {
            validators: [
                Validators.required,
                // createDNIDuplicateValidator(this)
            ],
            asyncValidators: [
                DNIAlreadyExistsValidator(this),
                DNIMediadorValidator(this._colegiadosS)
            ],
            // updateOn: 'blur'

        });
    }
    // ===========================================================================
    // ---------------------------------------------------------------------------
    get dataIdStored() {
        // const saved_data_string = localStorage.getItem('data_ids');
        const saved_data_string = this.getCookie('data_ids');
        let saved_data = null;
        saved_data_string && (saved_data = JSON.parse(saved_data_string));

        return saved_data;

    }

    // ===========================================================================
    // ---------------------------------------------------------------------------
    public getEmptyAllData(): IAllData {

        return Object.assign({}, this.getEmptyRecord(), {
            lista_invitados: [],
        });

    }

    // ---------------------------------------------------------------------------
    public getEmptyRecord(): IIncripcionRecord {

        return Object.assign({}, this.getEmptyPersonaRecord(), {
            id_inscripcion: null,
            id_padre: null,
            relacion_padre: null,
            ha_asistido: false,
            fecha_asistencia: null,
            fecha_asistencia_cocktel: null,
            fecha_envio_email: null,
            fecha_pendiente: null,
            con_factura: false,
            importe_factura: 0,
            codigo_qr: '',
            tipo_inscripción: '',
            codigo_autorizacion: '',
            fecha_alta: '',
            empresa_inivitacion: null,
            foro1: null,
            foro2: null,
            tipo_inscripcion: '',
            codigo_reserva: '',
            reservado: false
        });
    }

    // ---------------------------------------------------------------------------
    public getEmptyPersonaRecord(): IPersonaRecord {
        return {
            dni: '',
            nombre: '',
            apellido1: '',
            apellido2: '',
            empresa: '',
            tipo_empresa: '',
            cargo: '',
            direccion: '',
            codigo_postal: '',
            ciudad: '',
            pais: '',
            telefono: '',
            email: '',
            empresa_invitacion: '',
            acto_social: 0
        };
    }

    // ---------------------------------------------------------------------------
    public setField(field_name: string, field_value: any): void {

        this.inscription_record[field_name] = this._toMySQLFormat(field_value);

    }

    // ---------------------------------------------------------------------------
    public getFieldValue(field_name: string): any {

        return this.inscription_record[field_name];

    }

    // ---------------------------------------------------------------------------
    public existeInivitado(dni: string): boolean {
        const invitado = this.lista_invitados.find(e => e.dni === dni);

        return invitado ? true : false;
    }

    // ---------------------------------------------------------------------------
    public existeDNI(dni: string) {
        const self = this;

        return new Observable<any>((observer: Observer<any>) => {
            const call_params: ICallParams = {
                class: 'Inscripciones',
                accion: 'existeDato',
                filtro: "dni = '" + dni + "'"
            };
            self._RemoteCallCommonS.sendJSONPost(call_params).subscribe(
                (r: any) => {
                    if (!r.error.codigo) {
                        observer.next(r.datos)
                    }
                },
                (e) => observer.error(e)
            );
        });
    }

    // ---------------------------------------------------------------------------
    public existeCodigoReserva(codigo_reserva: string) {
        const self = this;

        return new Observable<any>((observer: Observer<any>) => {
            const call_params: ICallParams = {
                class: 'Inscripciones',
                accion: 'existeDato',
                filtro: "codigo_reserva = '" + codigo_reserva + "'"
            };
            self._RemoteCallCommonS.sendJSONPost(call_params).subscribe(
                (r: any) => {
                    if (!r.error.codigo) {
                        observer.next(r.datos)
                    }
                },
                (e) => observer.error(e)
            );
        });
    }

    // ---------------------------------------------------------------------------
    public esMediador(dni: string): Observable<boolean> {
        const self = this;

        return new Observable<any>((observer: Observer<boolean>) => {
            const call_params: ICallParams = {
                class: 'Inscripciones',
                accion: 'esMediadorColegiadoJSON',
                params: JSON.stringify({ dni: dni })
            };
            self._RemoteCallCommonS.sendJSONPost(call_params).subscribe(
                (r: any) => {
                    if (!r.error.codigo) {
                        observer.next(r.datos.es_mediador);
                    } else {
                        observer.next(false);
                    }
                },
                (e) => observer.error(e)
            );
        });
    }

    // ---------------------------------------------------------------------------
    // Manda servidor los datos como pendientes
    public guardaComoPendientes(): Observable<any> {
        const self = this;

        return new Observable((observer: Observer<any>) => {
            this._saveSessionCurrentInfo();
            const current_info = {
                iaPral: self.inscription_record,
                ibInvitado: null,
                icAcompanantes: self._personas2Inscripciones(self.lista_invitados)
            }
            const call_params: ICallParams = {
                class: 'GrabaInscripcionesAcompanantes',
                accion: 'grabaNuevasInscripcionesAcompanantes',
                inc_json: "acompanantes",
                argumentos: JSON.stringify(current_info)
            };

            self._RemoteCallCommonS.sendJSONPost(call_params).subscribe(
                (r: any) => {
                    if (r.error.codigo) {
                        observer.error(r.error.texto);
                    } else {
                        localStorage.setItem('data_ids', JSON.stringify(r.datos))
                        this._saveCookie('data_ids', JSON.stringify(r.datos));
                        observer.next(false);
                    }
                },
                (e) => observer.error(e)
            );
        });

    }

    // ---------------------------------------------------------------------------
    // Manda servidor los datos como confirmado
    public confirmarInscripciones(): Observable<any> {
        const self = this;
        return new Observable((observer: Observer<any>) => {
            if (!this.dataIdStored) {
                observer.error('No se encuentran datos para confirmar!');
                return;
            }
            const call_params: ICallParams = {
                class: 'GrabaInscripcionesAcompanantes',
                accion: 'confirmarInscripciones',
                inc_json: "acompanantes",
                argumentos: this.dataIdStored
            };

            self._RemoteCallCommonS.sendJSONPost(call_params).subscribe(
                (r: any) => {
                    if (r.error.codigo) {
                        observer.error(r.error.texto);
                    } else {
                        observer.next(false);
                    }
                },
                (e) => observer.error(e)
            );
        });

    }

    // ---------------------------------------------------------------------------
    // Borra las incripciones grabadas como pendiente cuando se produce
    //     un error en el pago
    public deleteInscripcionPendientes(): Observable<any> {
        const self = this;

        return new Observable((observer: Observer<any>) => {
            if (!this.dataIdStored) {
                observer.error('No se encuentran datos pendientes que borrar!');
                return;
            }
            const call_params: ICallParams = {
                class: 'GrabaInscripcionesAcompanantes',
                accion: 'eliminarInscripciones',
                inc_json: "acompanantes",
                argumentos: this.dataIdStored
            };

            self._RemoteCallCommonS.sendJSONPost(call_params).subscribe(
                (r: any) => {
                    if (r.error.codigo) {
                        observer.error(r.error.texto);
                    } else {
                        this.removePreviousSavedData();
                        observer.next(false);
                    }
                },
                (e) => observer.error(e)
            );
        });

    }

    // ---------------------------------------------------------------------------
    public removePreviousSavedData(): void {
        localStorage.removeItem('data');
        localStorage.removeItem('data_ids');        // Todo borrar las cookies data u data_ids
        this._deleteCookie('data');
        this._deleteCookie('data_ids');

    }


    // ---------------------------------------------------------------------------
    // Metodo para manejar el final de la inscripción
    public readInscriptionData() {

        this._getSessionCurrentInfo();

    }

    // ===========================================================================
    // ---------------------------------------------------------------------------
    private _saveSessionCurrentInfo(): void {
        const current_info = {
            iaPral: this.inscription_record,
            ibInvitado: null,
            icAcompanantes: this._personas2Inscripciones(this.lista_invitados)
        }

        localStorage.setItem('data', JSON.stringify(current_info));
        this._saveCookie('data', JSON.stringify(current_info));

    }

    // ---------------------------------------------------------------------------
    private _getSessionCurrentInfo(): void {
        const saved_data_string_localstorage = localStorage.getItem('data');
        const saved_data_string = this.getCookie('data');
        if (saved_data_string) {
            const saved_data: IRemoteRecordFormat = JSON.parse(saved_data_string);
            this.inscription_record = saved_data.iaPral;
            // this.inscription_record = saved_data.ibInvitado;
            this.lista_invitados = saved_data.icAcompanantes;
        }

    }

    // ---------------------------------------------------------------------------
    private _toMySQLFormat(value: any): any {
        let transformed_value = null;
        switch (typeof value) {
            case 'object':
                if (value instanceof Date) {
                    transformed_value = value.toISOString().substr(0, 19).replace('T', ' ');
                }
                break;
            default:
                transformed_value = value;
                break;
        }

        return transformed_value;
    }

    // ---------------------------------------------------------------------------
    // Convertir un registro de tipo persona a tipo Inscripción,
    //   añadiendo los campos que puedan faltarle
    private _personas2Inscripciones(personas: IPersonaRecord[]): IIncripcionRecord[] {
        const ret: IIncripcionRecord[] = [];
        for (let p of personas) {
            ret.push(Object.assign({}, this.getEmptyRecord(), p, {
                tipo_inscripcion: this._getTipoInscripcionAcompanante()          // Set tipo inscripción en función del tipo de inscripción del id_padre
            }));
        }

        return ret;
    }

    // ---------------------------------------------------------------------------
    private _getTipoInscripcionAcompanante(): string {
        let tipo_inscripcion_acompanante = '0';

        switch (this.inscription_record.tipo_inscripcion) {
            case '1':
                tipo_inscripcion_acompanante = '6';
                break;
            case '2':
                tipo_inscripcion_acompanante = '7';
                break;
            case '3':
                tipo_inscripcion_acompanante = '8';
                break;
            case '4':
                tipo_inscripcion_acompanante = '9';
                break;
        }
        return tipo_inscripcion_acompanante;
    }


    private _saveCookie(name:string, value: any, options = {}): void {
        // Configuración por defecto
        const defaults = {
            days: 7,         // Duración en días
            path: '/',       // Path por defecto
            domain: document.location.hostname,
            secure: false,    // Solo HTTPS
            sameSite: 'Lax'  // Protección CSRF
        };
        
        // Combinar opciones con defaults
        const opts = {...defaults, ...options};
        
        // Calcular fecha de expiración
        let expires = '';
        if (opts.days) {
            const date = new Date();
            date.setTime(date.getTime() + (opts.days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        
        // Codificar el valor para caracteres especiales
        const encodedValue = encodeURIComponent(value);
        
        // Construir el string de la cookie
        let cookieString = `${name}=${encodedValue}${expires}; path=${opts.path}`;
        
        // Añadir opciones adicionales
        if (opts.domain) cookieString += `; domain=${opts.domain}`;
        if (opts.secure) cookieString += '; secure';
        if (opts.sameSite) cookieString += `; sameSite=${opts.sameSite}`;
                

        // Establecer la cookie
        document.cookie = cookieString;

    }

    public getCookie(name:string): any {
        const valorCookie = document.cookie
            .split('; ')
            .find(fila => fila.startsWith(name + '='))
            ?.split('=')[1];
        let decoded_value:any = null;
        if (valorCookie) {
            decoded_value = decodeURIComponent(valorCookie);
        }
    
        return decoded_value || null;
    }

    public _deleteCookie(name:string, domain:any=null, path='') {
        // Parámetros por defecto
        domain = domain || document.location.hostname;
        path = path || '/';
        
        // Elimina la cookie con varias opciones para asegurarse
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + path + ';';
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=' + domain + '; path=' + path + ';';
    }

}
